import { render } from "./CreateMandateOk.vue?vue&type=template&id=24de0192&scoped=true"
import script from "./CreateMandateOk.vue?vue&type=script&lang=js"
export * from "./CreateMandateOk.vue?vue&type=script&lang=js"

import "./CreateMandateOk.vue?vue&type=style&index=0&id=24de0192&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24de0192"]])

export default __exports__